export const transactionsRouteNames = {
  transactions: 'transactions-v2-new',
  transactionDetails: 'transaction-details-v2-new',
}
